__turbopack_context__.v({
  "promotedVideo": "Litgkq_promotedVideo",
});
